"use client";
export { Link as default } from "../../../_Builtin/Basic";
